import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <section className="about-us" id='about-us'>
      <h2>About Us</h2>
      <p>
        Our mission is to empower businesses to manage their human resources effectively, ensuring a seamless and efficient workflow. We are committed to innovation and delivering exceptional services tailored to your needs.
      </p>
      <p>
        Vision: To be the leading platform in HR management, fostering growth and productivity.
      </p>
    </section>
  );
};

export default AboutUs;
